const SIMILAR_BRANDS_SORTING_CRITERIA = {
  BRAND_ID: 'BRAND_ID',
}

export default SIMILAR_BRANDS_SORTING_CRITERIA
